export const Spanish = {
  Footer: {
    copyRight:
      "© Derechos de autor Clinion 2023. Todos los derechos reservados.",
    terms: "Términos y condiciones",
    privacy: "Política de privacidad",
    designed: "Diseñado y desarrollado por Clinion",
  },
  error: {
    BloodSugarRecord: {
      Blood_sugar_value: {
        empty: "Se requiere el valor de azúcar en sangre.",
        base: "El valor de azúcar en sangre debe ser un número.",
      },
      time_Dropdown_Value: {
        required: "Por favor seleccione el valor de tiempo.",
      },
      Meal_Code_Dropdown: {
        required: "Por favor seleccione el código de comida.",
      },
      MealTime: "Por favor, seleccione una hora de comida válida.",
    },
    Hypoglycemia: {
      bloodSugarValue: {
        empty: "Se requiere el valor de azúcar en sangre.",
        base: "El valor de azúcar en sangre debe ser un número.",
      },
      symptoms: {
        required: "Se debe seleccionar al menos un síntoma.",
        base: "Se debe seleccionar al menos un síntoma.",
      },
      reactionRecognizedBy: {
        required: "Se requiere quién reconoció la reacción.",
      },
      treatment: {
        required: "Se debe seleccionar al menos un tratamiento.",
        min: "Se debe seleccionar al menos un tratamiento.",
      },
      time: {
        time: "Por favor seleccione el tiempo.",
        validTime: "Por favor seleccione un tiempo válido.",
      },
      date: {
        date: "Por favor seleccione la fecha.",
        validDate: "Por favor seleccione una fecha válida.",
      },
      other: {
        other: "Se requiere otro valor.",
      },
      symptoms: {
        symptoms: "Se debe seleccionar al menos un síntoma.",
      },
      treatment: {
        treatment: "Se debe seleccionar al menos un tratamiento.",
      },
    },
  },
  Message: {
    unableInsert: "No se pudo insertar los datos de la página",
    noDataChanged: "No se han cambiado los datos",
  },
  LoginTitle: {
    language_title: "Por favor seleccione su preferencia de idioma",
    enterNumb_title: "Por favor, ingrese su número de móvil y verifique",
    selectLang_label: "Elige tu idioma preferido",
    enterNumb_label: "Por favor, ingrese su número de móvil",
    enterOTP_label: "Ingrese código",
    sendOPT_btnText: "ENVIAR código",
    verifyOTP_btnText: "VERIFICAR código",
    proceed_btnText: "CONTINUAR",
    varifyNum_title: "Verificar su número de móvil",
    backImage_title:
      "Descentralice sus ensayos con Clinion eCOA para obtener Datos del Mundo Real Mejorados",
    mobileNo: "Número de móvil",
  },

  NavbarTitle: {
    patient_num: "Identificación del sujeto",
    protocol_num: "ID del protocolo",
  },

  Patient: {
    studyTitle: "Título del estudio",
    patient_Head: "Detalles del Asunto",
    siteId: "Nombre del sitio ID",
    investigator_Name: "Nombre del investigador",
    siteAdd: "Dirección del sitio y contacto",
    screeningDate: "Fecha de detección",
    screening_Number: "Número de detección",
  },

  InstructionTitle: {
    instruction_head: "INSTRUCCIONES GENERALES",
  },

  visitsTitle: {
    visits_head: "Visitas",
    legend: "Leyenda",
  },

  Language_Menu: [
    {
      id: 1,
      name: "Inglés",
    },
    {
      id: 2,
      name: "Español",
    },
  ],

  Form_Sidebar: {
    visitnum: "VISITA 1-SCREENING/BASELINE",
    daynum: "Día-15",
    date: "22/Mayo/2023",
    formText1: "Hipoglucemia",
    bloodSugar1: "Registro de azúcar en sangre 1",
    bloodSugar2: "Registro de azúcar en sangre 2",
    bloodSugar3: "Registro de azúcar en sangre 3",
    bloodSugar4: "Registro de azúcar en sangre 4",
    bloodSugar5: "Registro de azúcar en sangre 5",
    bloodSugar6: "Registro de azúcar en sangre 6",
    bloodSugar7: "Registro de azúcar en sangre 7",
    legend: "Leyenda",
  },

  visitPageandStatus: {
    startDate: "Fecha de inicio",
    endDate: "Fecha de finalización",
    active: "Activo",
    inProgress: "En progreso",
    Completed: "Completado",
    title: "Páginas y Estado",
    visitnum: "VISITA 1-SCREENING/BASELINE",
    treatmentDetails: "Detalles del tratamiento con H1 Antihistamínico",
    weeklyActivity: "Actividad semanal de urticaria",
    generalForm: "Formularios Generales",
    notStarted: "No Iniciado",
    selectDate: "Seleccionar Fecha:",
    emptyDataText:
      "Este es el lugar donde encontrarás todos tus registros guardados. Haz clic en el botón AGREGAR NUEVO para añadir registros y aparecerán aquí",
    savedRecords: "Registros Guardados",
    record_Date: "Fecha del Registro",
    status: "Estado",
  },

  HypoglycemiaTitles: {
    sym: "SÍNTOMAS",
    treatment: "TRATAMIENTO",
    reaction: "REACCIONES",
    symOther: "SÍNTOMAS (OTROS)",
    action: "Acciones",
    insulin: "INSULINA",
    Record_Number: "Número de Registro",
    Date: "Fecha",
    Time: "Hora",
    Blood_sugar_value: "Valor de Azúcar en Sangre",
    Symptoms: "Síntomas sentidos o ¿qué notaste?",
    Recognize: "La reacción fue reconocida por",
    Treatment: "Tratamiento necesario para la reacción",
    Symptoms_Options: [
      { text: "sudoración", value: "1", english: "sweating" },
      { text: "temblores", value: "2", english: "shaking" },
      {
        text: "palpitaciones del corazón",
        value: "3",
        english: "heart palpitations",
      },
      {
        text: "problemas de visión",
        value: "4",
        english: "problems with vision",
      },
      {
        text: "cambio de comportamiento",
        value: "5",
        english: "change in behavior",
      },
      { text: "confusión", value: "6", english: "confusion" },
      { text: "desmayo", value: "7", english: "fainting" },
      { text: "otro", value: "8", english: "otro" },
    ],
    // Reaction_Recognized_By_Options: [
    //   "Usted mismo",
    //   "Prueba de rutina en su medidor",
    //   "Alguien más",
    // ],
    Reaction_Recognized_By_Options: [
      { text: "Usted mismo", value: "1", english: "Yourself" },
      {
        text: "Prueba de rutina en su medidor",
        value: "2",
        english: "Routine test on your meter",
      },
      { text: "Alguien más", value: "3", english: "Someone else" },
    ],
    Treatment_options: [
      {
        text: "Jugo/Comida/Tabletas de glucosa",
        value: "1",
        english: "Juice/Food/Glucose tablets",
      },
      {
        text: "Ayuda de otra persona",
        value: "2",
        english: "Help from someone else",
      },
      {
        text: "Inyección de Glucagón",
        value: "3",
        english: "Injection of Glucagon",
      },
      {
        text: "Hospital/Ambulancia",
        value: "4",
        english: "Hospital/Ambulance",
      },
    ],
  },
  BloodSugarRecords: {
    action: "Acciones",
    insulin: "INSULINA",
    weeklyActivity:
      "Documentación del puntaje de actividad semanal de azúcar en sangre",
    visitnum: "VISITA-1 (Día-14) (Semana-2)",
    newRecord: "AGREGAR NUEVO REGISTRO",
    Time: "Hora",
    Meal_Time: "Hora de la Comida",
    Meal_Code: "Código de la Comida",
    Blood_sugar_value: "Azúcar en Sangre",
    Bolus_Insulin: "Insulina Bolus",
    Insulin_Type: "Tipo de Insulina",
    Insulin_Type_2: "Tipo de Insulina",
    Basal_Insulin: "Insulina Basal",
    Pump_Insulin_Units: "Unidades de Insulina de la Bomba",
    Pump_Insulin_Type: "Tipo de Insulina de la Bomba",
    Total_Bolus: "Total Bolus",
    Total_Basal: "Total Basal",
    Total_Pump: "Total de la Bomba",
    dropdown: [
      {
        id: "1",
        name: "Desplegable1",
      },
      {
        id: "2",
        name: "Desplegable2",
      },
      {
        id: "3",
        name: "Desplegable3",
      },
    ],
    Time_Dropdown: [
      {
        id: "1",
        name: "12:00 AM",
      },
      {
        id: "2",
        name: "01:00 AM",
      },
      {
        id: "3",
        name: "02:00 AM",
      },
      {
        id: "4",
        name: "03:00 AM",
      },
      {
        id: "5",
        name: "04:00 AM",
      },
      {
        id: "6",
        name: "05:00 AM",
      },
      {
        id: "7",
        name: "06:00 AM",
      },
      {
        id: "8",
        name: "07:00 AM",
      },
      {
        id: "9",
        name: "08:00 AM",
      },
      {
        id: "10",
        name: "09:00 AM",
      },
      {
        id: "11",
        name: "10:00 AM",
      },
      {
        id: "12",
        name: "11:00 AM",
      },
      {
        id: "13",
        name: "12:00 PM",
      },
      {
        id: "14",
        name: "01:00 PM",
      },
      {
        id: "15",
        name: "02:00 PM",
      },
      {
        id: "16",
        name: "03:00 PM",
      },
      {
        id: "17",
        name: "04:00 PM",
      },
      {
        id: "18",
        name: "05:00 PM",
      },
      {
        id: "19",
        name: "06:00 PM",
      },
      {
        id: "20",
        name: "07:00 PM",
      },
      {
        id: "21",
        name: "08:00 PM",
      },
      {
        id: "22",
        name: "09:00 PM",
      },
      {
        id: "23",
        name: "10:00 PM",
      },
      {
        id: "24",
        name: "11:00 PM",
      },
    ],
    Meal_Code_Dropdown: [
      {
        id: "1",
        name: "Antes de la comida",
        english: "Pre Meal",
      },
      {
        id: "2",
        name: "2 horas después de la comida",
        english: "2 hours post meal",
      },
      {
        id: "3",
        name: "Hora de dormir",
        english: "Bedtime",
      },
    ],
    Pump_Insulin_Type_Dropdown: [
      {
        id: "1",
        name: "Humalog",
        english: "Humalog",
      },
      {
        id: "2",
        name: "Novolog",
        english: "Novolog",
      },
      {
        id: "3",
        name: "FiAsp",
        english: "FiAsp",
      },
      {
        id: "4",
        name: "Otro",
        english: "Other",
      },
    ],
    Insulin_Type_Dropdown: [
      {
        id: "1",
        name: "Lantus",
        english: "Lantus",
      },
      {
        id: "2",
        name: "Levemir",
        english: "Levemir",
      },
      {
        id: "3",
        name: "Tresiba",
        english: "Tresiba",
      },
      {
        id: "4",
        name: "NPH",
        english: "NPH",
      },
      {
        id: "5",
        name: "Regular",
        english: "Regular",
      },
      {
        id: "6",
        name: "Humalog",
        english: "Humalog",
      },
      {
        id: "7",
        name: "Novolog",
        english: "Novolog",
      },
      {
        id: "8",
        name: "Apidra",
        english: "Apidra",
      },
      {
        id: "9",
        name: "FiAsp",
        english: "FiAsp",
      },
      {
        id: "10",
        name: "Otro",
        english: "Other",
      },
    ],
  },

  selectedLabel: {
    dropdownLabel: "seleccionar",
  },
  ButtonText: {
    Add_New_Entry: "Agregar Nuevo",
    Save: "Guardar",
    Submit: "Enviar",
    Cancel: "Cancelar",
    Previous: "Anterior",
    Next: "Siguiente",
    backtosaved: "VOLVER A REGISTROS GUARDADOS",
    backtoVisit: "VOLVER A VISITAS",
  },
  AlertMsg: {
    selectedRecordDate: "Por favor seleccione la fecha",
    selectVisitDate:
      "No se encontró ninguna visita activa para la fecha seleccionada",
    navigateToHypoglycemia:
      "El nivel de azúcar en sangre es inferior a 54. Complete el formulario de hipoglucemia",
    maxLimitToEnterForm: "Puede ingresar un máximo de 10 registros por día",
    logout: "¿Quieres cerrar sesión?",
  },
};
